var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3205 2.39304L12.5374 4.50747C13.6356 6.41562 13.1947 8.91878 11.4651 10.596C11.4651 10.596 9.36728 12.6306 13.1709 16.3191C16.9734 20.0064 19.0729 17.9733 19.0729 17.9733C20.8026 16.296 23.3839 15.8686 25.3517 16.9335L27.5321 18.1135C30.5036 19.7215 30.8544 23.7622 28.2427 26.295C26.6734 27.8168 24.7507 29.001 22.6254 29.079C19.0477 29.2106 12.9718 28.3326 6.87694 22.4224C0.782122 16.5122 -0.123352 10.6204 0.0122851 7.15109C0.0928538 5.09019 1.314 3.22588 2.8834 1.70406C5.49518 -0.828584 9.66219 -0.488291 11.3205 2.39304Z",
    fill: "#E3E6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.58cc32444671430505c58f7e329417bc.svg";
export { ForwardRef as ReactComponent };